@if (selectedSiteId$ | async; as siteId) {
    <div class="content-wrapper">
        <div class="date-controls-wrapper mb-2">
            <myrtls-custom-date-picker
                [disabled]="loading"
                (periodSelectionChange)="periodSelectionChange($event, siteId)"
            ></myrtls-custom-date-picker>
            <div>
                <mat-checkbox
                    [disabled]="loading"
                    class="alerting-checkbox"
                    [checked]="(alertingOnly$ | async) || false"
                    (change)="onAlertingOnlyChanged($event.checked)"
                    >Show Alerting Only</mat-checkbox
                >
                <mat-form-field class="range-dropdown">
                    <mat-label>Visible Range</mat-label>
                    <mat-select [disabled]="loading" [formControl]="selectedRangeControl">
                        @for (range of ranges; track range) {
                            <mat-option [value]="range">
                                {{ range }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <mat-accordion multi>
            @for (group of metricGroups$ | async; track group; let i = $index) {
                <mat-expansion-panel class="expansion-panel" [expanded]="true" [attr.group]="group">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{ group }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-container>
                        @for (metric of metrics; track metricById($index, metric)) {
                            <div>
                                @if (metric && metric.group === group) {
                                    <div class="chart-container">
                                        @if (metric.id) {
                                            <div class="header-container">
                                                <h3 class="title" [attr.id]="metric.id">
                                                    {{ metric.name }} <span class="text-xs mx-1 text-dark-600">{{ metric.nameSuffix }}</span>
                                                </h3>
                                                <!--button
                        class="export-button"
                        mat-button
                        color="primary"
                        (click)="exportCSV(metric.id)"
                        >
                        Export
                      </button-->
                                            </div>
                                        }
                                        @if (metric.options; as options) {
                                            <div
                                                class="canvas-wrapper"
                                                echarts
                                                [style.height]="getChartHeight(metric.id, options)"
                                                [options]="options"
                                            ></div>
                                        }
                                        @if (metric.tableOptions; as options) {
                                            <div class="table-container">
                                                <table mat-table [dataSource]="options.rows">
                                                    @for (column of options.columns; track column) {
                                                        <ng-container [matColumnDef]="column.name">
                                                            <th mat-header-cell *matHeaderCellDef>{{ column.alias }}</th>
                                                            <td
                                                                mat-cell
                                                                *matCellDef="let element"
                                                                [style.color]="element[column.name].color ? element[column.name].color : '#000'"
                                                            >
                                                                @if (Array.isArray(element[column.name].value)) {
                                                                    <div>
                                                                        <myrtls-state-timeline
                                                                            [data]="element[column.name].value"
                                                                            [colorMapping]="element[column.name].colorMapping"
                                                                        ></myrtls-state-timeline>
                                                                    </div>
                                                                }
                                                                @if (!Array.isArray(element[column.name].value)) {
                                                                    <div>{{ element[column.name].value }}</div>
                                                                }
                                                            </td>
                                                        </ng-container>
                                                    }
                                                    <tr class="no-data-row" *matNoDataRow>
                                                        <td class="mat-cell no-data" colspan="9999">{{ options.noDataText || 'No data found.' }}</td>
                                                    </tr>
                                                    <tr mat-header-row *matHeaderRowDef="getColumns(options); sticky: true"></tr>
                                                    <tr mat-row *matRowDef="let row; columns: getColumns(options)"></tr>
                                                </table>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        }
                    </ng-container>
                </mat-expansion-panel>
            }
        </mat-accordion>
    </div>
}
@if (loading) {
    <div class="loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
}
